import styled from 'styled-components'

export default styled.div`
  flex-shrink: 0;
  width: ${props => props.size === 'smaller' ? '100px' : '150px'};
  padding-left: ${props => props.noPaddingLeft ? 0 : '20px'};

  @media (max-width: 768px) {
    padding-left: ${props => props.noPaddingLeft ? 0 : '5px'};
    width: ${props => props.size === 'smaller' ? 'inherit' : '100px'};
  }
`
